import {inject, Injectable} from "@angular/core";
import {GlobalModelService} from "../../Services/GlobalModel.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export abstract class BaseComponent {
  public gmService = inject(GlobalModelService);
  protected translate = inject(TranslateService);
  protected dialog = inject(MatDialog);
}
